import React from 'react';
import PropTypes from 'prop-types';
import find from 'lodash/find';
import get from 'lodash/get';
import cn from 'classnames';
import { EXPORT_TEXTS } from '@Services/ExportService/ExportConstants';
import Auth from '@Services/Auth';
import { ButtonWithIcon } from '@els/els-react--button';
import NotifyDialogsService from '@Containers/Dialogs/NotifyDialogsService';
import ExportRequestManager from '@Services/ExportRequestManager';

const EXPORT_TYPE = 'ChemQuote';
const CHECK_PROVIDERS = ['eMolecules', 'Labnetwork', 'Sigma Aldrich']; // One of them should be present

export default class ChemQuoteProviderComponent extends React.Component {
  // eslint-disable-next-line react/sort-comp
  checkIfShouldBeDisplayed() {
    const isChemQuoteEnabled = get(Auth.getUser(), 'details.settings.chemquoteEnabled');
    // eslint-disable-next-line react/destructuring-assignment
    const isCheckProviderPresent = !!find(this.props.providers, (provider) => provider.show && CHECK_PROVIDERS.includes(provider.label));

    return isChemQuoteEnabled && isCheckProviderPresent;
  }

  showExportBusyInfoDialog() {
    return NotifyDialogsService.openModalWindow({
      title: EXPORT_TEXTS.busyInfoDialogTitle,
      text: EXPORT_TEXTS.busyInfoDialogText,
      confirmText: EXPORT_TEXTS.busyInfoDialogButton,
      type: 'info',
      backdrop: 'static',
      onConfirm: () => {
        // eslint-disable-next-line no-unused-expressions,react/destructuring-assignment
        this.props.closeMenu && this.props.closeMenu();
      },
      trackingOptions: {
        component: 'Export',
      },
    });
  }

  providerClickHandler = (event) => {
    event.preventDefault();

    // eslint-disable-next-line react/destructuring-assignment
    this.props.onClick();

    if (ExportRequestManager.isBusy(EXPORT_TYPE)) {
      this.showExportBusyInfoDialog();
      return;
    }

    const { structure } = this.props;

    ExportRequestManager.sendExportRequest(EXPORT_TYPE, {
      databaseId: structure.databaseId,
      ids: [get(structure, 'details.id')],
    });

    // eslint-disable-next-line no-unused-expressions,react/destructuring-assignment
    this.props.closeMenu && this.props.closeMenu();
  };

  render() {
    const shouldDisplay = this.checkIfShouldBeDisplayed();

    return shouldDisplay ? (
      <tr role="menuitem">
        <td className="column-provider-logo">
          <div className="provider-image chemquote" />
        </td>
        <td>
          <ButtonWithIcon
            className={cn('provider-link provider-link--chemquote', 'e2e-novartis-chemquote')}
            sprite="UpRight"
            iconRight
            type="link"
            linkIconSize="xs"
            onClick={this.providerClickHandler}>
            Novartis ChemQuote
          </ButtonWithIcon>
        </td>
      </tr>
    ) : null;
  }
}

ChemQuoteProviderComponent.defaultProps = {
  onClick: () => null,
};

ChemQuoteProviderComponent.propTypes = {
  closeMenu: PropTypes.func.isRequired,
  providers: PropTypes.array.isRequired,
  structure: PropTypes.object.isRequired,
  onClick: PropTypes.func,
};
